/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Definition of the asset scope of the notification rule
 */
export type PublicNotificationRuleAssetScopeDto = {
    /**
     * Type of the notification rule asset scope
     */
    type: PublicNotificationRuleAssetScopeDto.type;
};

export namespace PublicNotificationRuleAssetScopeDto {

    /**
     * Type of the notification rule asset scope
     */
    export enum type {
        ALL = 'ALL',
        STATIC = 'STATIC',
        DYNAMIC = 'DYNAMIC',
    }


}
